<template> 

    <div class="modal fade" id="modalTask" role="dialog" aria-labelledby="modalTaskLabel" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content rounded-3">
                <div class="modal-header bg-secondary text-white border-0" style="padding:1.12rem;">
                    <h5 class="modal-title" style="width: 75%;">
                        <i class="ph-list icon-modal-size me-2"></i><span class="me-2">{{ localTask.ID_TASK > 0 ? 'Modifica Task' : 'Nuova Task' }}</span>
                    </h5>
                    <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div>
                <div class="modal-body p-2" style="height: 33rem;"> 

                     <div class="row mb-2" v-if="$root.isGod">
                        <div class="col-md-12 text-center">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="taskPerMe" :value="true"
                                    v-model="isPerMe">
                                <label class="form-check-label" for="taskPerMe">Task per me</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="taskPerAltri" :value="false"
                                    v-model="isPerMe">
                                <label class="form-check-label" for="taskPerAltri">Task per altri</label>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-md-6">
                            <label class="form-label">Nome</label>
                            <input type="text" v-model="localTask.TITOLO" class="form-control" placeholder="Nome della task">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Categoria</label>
                            <template v-if="localTask.CONDIVISO == 1">
                                <input class="form-control" disabled value="Le task condivise non possono avere una categoria" />
                            </template>
                            <template v-else>
                                <div v-if="categories.length > 0">
                                    <select class="form-select" v-model="localTask.FK_ID_CATEGORIA">
                                        <option disabled value="">Seleziona categoria</option>
                                        <option v-for="cat in categories" :key="cat.ID_CATEGORIA"
                                            :value="cat.ID_CATEGORIA">
                                            {{ cat.NOME }}
                                        </option>
                                    </select>
                                </div>
                                <div v-else>
                                    <input class="form-control" disabled value="Nessuna categoria creata" />
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-md-12">
                            <label class="form-label">Descrizione</label>
                            <textarea v-model="localTask.DESCRIZIONE" class="form-control" rows="3" placeholder="Dettagli della task"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label class="form-label">Priorità</label>
                            <select class="form-select" v-model="localTask.PRIORITY">
                                <option disabled value="">Seleziona priorità</option>
                                <option value="0">Bassa</option>
                                <option value="1">Media</option>
                                <option value="2">Alta</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Scadenza</label>
                            <Datepicker placeholder="Data scadenza" :dim="'md'" style="width: 100%;" v-model="localTask.DATA_SCADENZA" auto-apply model-type="dd/MM/yyyy HH:mm" :formats="{ input: 'dd/MM/yyyy HH:mm' }" :enable-time-picker="true" />
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-md-12">
                            <div class="form-check mb-3 text-center">
                                <input class="form-check-input" type="checkbox" id="isTaskShared" v-model="localTask.CONDIVISO" :true-value="1" :false-value="0">
                                <label class="form-check-label" for="isTaskShared"> Condividi con altri utenti</label>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="localTask.CONDIVISO">
                        <div class="col-md-12">
                            <label class="form-label">Assegna a utenti</label>
                            <input type="text" class="form-control mb-2" placeholder="Cerca utente..." v-model="filtroUtente">
                            <div style="overflow-x: auto; max-width: 100%; white-space: nowrap;">
                                <div class="d-flex flex-nowrap" style="gap: 8px;">
                                    <div v-for="utente in utentiDisponibili" :key="utente.ID_UTENTE"
                                        @click="toggleUtente(utente.ID_UTENTE)" :class="['d-flex align-items-center rounded-pill px-2 py-1',
                                            utentiSelezionati.includes(utente.ID_UTENTE) ? 'bg-primary text-white' : 'bg-light text-dark'
                                        ]" style="min-width: max-content; cursor: pointer; user-select: none;">
                                        <div class="me-2">
                                            <img v-if="utente.ID_UTENTE > 0 && utente.URL_AVATAR != 'placeholder.jpg'" :src="utente.URL_AVATAR" alt="avatar" class="avatar-img" />
                                            <i v-else class="fa fa-user text-secondary avatar-img d-flex align-items-center justify-content-center" style="font-size: 20px;"></i>
                                        </div>
                                        <small>{{ utente.USERNAME }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
                    <button class="btn btn-secondary float-end" @click="conferma()">
						<i class="far fa-save me-1"></i> {{ localTask.ID_TASK > 0 ? 'Salva modifiche' : 'Crea task' }}
                    </button>                                   
                </div>
            </div>
        </div>
    </div>	  

</template>


<script>  

import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

export default {
    name: 'ModalToDo',

    components: {
        Datepicker,
    },

    props: {
        task: {
            type: Object,
            required: true,
        },
        categories: {
            type: Array,
            required: false,
        },
        arrayUtenti: {
            type: Array,
            required: true,
        }
    },
    
    data() {
        return {
            filters: global.filters,
            localTask: {},
            utentiSelezionati: new Array(),
            filtroUtente: '',
            arrayItems : new Array(),
            isPerMe: true,
        };
    },
    
    methods: {
        conferma() {
            if (this.$root.isGod) {
                if (this.isPerMe) {
                    if (!this.utentiSelezionati.includes(this.$root.utente.ID_UTENTE)) {
                        this.utentiSelezionati.push(this.$root.utente.ID_UTENTE);
                    }
                } else {
                    this.utentiSelezionati = this.utentiSelezionati.filter(id => id !== this.$root.utente.ID_UTENTE);
                }
            } else {
                if (!this.utentiSelezionati.includes(this.$root.utente.ID_UTENTE)) {
                    this.utentiSelezionati.push(this.$root.utente.ID_UTENTE);
                }
            }

            const taskConUtenti = {
                ...this.localTask,
                UTENTI_ASSEGNATI: this.utentiSelezionati
            };

            if ((this.arrayItems || []).length > 0) {
                const payload = {
                    task: taskConUtenti,
                    array_items: this.arrayItems,
                    FK_ID_UTENTE: this.$root.utente.ID_UTENTE
                };

                utils.ajax('todo/task/insert/multipla', payload, response => {
                    if (response.esito == 0) {
                        utils.alert.success("Task associata correttamente agli item selezionati.");
                        this.filters.closePopUp('modalTask');
                        this.arrayItems = [];
                    } else {
                        utils.alert.danger("Errore nella creazione multipla: " + response.messaggio);
                    }
                });
                this.$emit('task-multipla-creata');
                return;
            }

            this.$emit('salva', taskConUtenti);
        },

        closeModalToDo(){
            this.filters.closePopUp("modalTask")
        },

        createTask(modulo) {
            this.localTask = { ID_TASK: 0, CONDIVISO: 0, FK_ID_MODULO: modulo };
            this.isPerMe = this.$root.isGod ? true : undefined;
            this.utentiSelezionati = [];
            this.filtroUtente = '';
            this.arrayItems = [];
            filters.openPopUp('modalTask');
        },
        createMoreTask(arraySelezionati, modulo) {
            this.localTask = { ID_TASK: 0, CONDIVISO: 0, FK_ID_MODULO: modulo };
            this.arrayItems = arraySelezionati;
            var modal = filters.openPopUp('modalTask');
        },

        editTask() {
            this.localTask = utils.clone(this.task);
            var modal = filters.openPopUp('modalTask');
        },
        toggleUtente(idUtente) {
            const index = this.utentiSelezionati.indexOf(idUtente);
            if (index == -1) {
                this.utentiSelezionati.push(idUtente);
            } else {
                this.utentiSelezionati.splice(index, 1);
            }
        },
        aggiungiPromemoria(task) {
            this.$emit('aggiungi-promemoria', task);
        },
        modificaPromemoria(task) {
            this.$emit('modifica-promemoria', task);
        }
    },

    watch: {
        task: {
            immediate: true,
            handler(nuovo) {
                if (!nuovo) return;
                this.localTask = { ...nuovo, CONDIVISO: nuovo.CONDIVISO ? 1 : 0 };
                this.utentiSelezionati = (nuovo.UTENTI_ASSEGNATI || []).map(u => {
                    return typeof u == 'object' ? u.ID_UTENTE : u;
                });
            }
        },
        'localTask.CONDIVISO'(val) {
            if (!val) this.utentiSelezionati = [];
        },

        isPerMe(val) {
            if (!val && this.$root.isGod) {
                this.localTask.CONDIVISO = 1; 
            }
        }
    },

    computed: {
        utentiDisponibili() {
            const testoFiltro = this.filtroUtente.toLowerCase().trim();
            return this.arrayUtenti.filter(u =>
                (this.isPerMe || u.ID_UTENTE !== this.$root.utente.ID_UTENTE) &&
                (!testoFiltro || u.USERNAME.toLowerCase().includes(testoFiltro))
            );
        }
    }  

};
</script>

